import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import NewTask from "../../Popups/NewTask";
import NewNote from "../../Popups/NewNote";
import { DisplayMsg } from "../../../services/toastService";
import {
  setCurrentClientId,
  setCurrentTicketNo,
  setSearchFrom,
} from "../../../store/reducers/SharedLayoutDataSlice";
import {
  clearTicketTaskFilters,
  setClientId,
  setStatus,
  setTicketCustomerId,
  setType,
} from "../../../store/reducers/TicketTaskFilter";
import { setUrl } from "../../../handlers";

const ClientProgress = React.memo((props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [PracticeInfo, setPracticeInfo] = useState(null);

  const [Identifiers, setIdentifier] = useState([
    1, 6, 8, 10, 15, 7, 17, 9, 18, 11, 14, 23, 24, 19, 20, 21, 22, 12,
  ]);

  const [percentage, setPercentage] = useState(0);

  let completedPercentage = 0;

  const [AllTasks, setAllTasks] = useState();
  const [Progress, setProgress] = useState({
    overDueTask: "",
    practiceSetupStatus: "",
    clientInfo: "",
    percentage: "0",
  });
  const [ClientInfo, setClientInfo] = useState();
  const [PopupTask, setPopupTask] = useState(false);
  const [PopupNote, setPopupNote] = useState(false);
  const [progressData, setProgressData] = useState(true);

  useEffect(() => {
    dispatch(setCurrentClientId(props?.data.customerId));
    LoadProgressData();
  }, [props]);

  const LoadProgressData = () => {
    try {
      setClientInfo(props?.data.selectedCustomer);
      const formData = new FormData();
      document.getElementById("loader").style.display = "block";
      formData.append("entitySeqNum", props?.data.customerId);
      fetch(setUrl("HOME", "LOADPROGRESSDATA", true), {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((result) => {
          if (result.PracticeData && result.PracticeData.length > 0) {
            setPracticeInfo(result.PracticeData);
            if (result.AllTasks !== "") {
              setAllTasks(JSON.parse(result.AllTasks));
            }
            setProgress((detailProgress) => ({
              ...detailProgress,
              overDueTask:
                result.OverdueTasks !== ""
                  ? JSON.parse(result.OverdueTasks)
                  : "",
              practiceSetupStatus:
                result.PracticeSetupStatus !== ""
                  ? result.PracticeSetupStatus
                  : "",
            }));
            setProgressData(true);
          } else {
            setProgressData(false);
          }

          LoadSetupProgress(result);
          document.getElementById("loader").style.display = "none";
        })
        .catch((error) => {
          DisplayMsg("2", error.Message);
        });
    } catch (e) {
      DisplayMsg("2", "Uanble to Process the Request");
    }
  };

  const ShowTicketDetail = (ticketInfo) => {
    dispatch(setSearchFrom("dashboard"));
    dispatch(setCurrentTicketNo(ticketInfo.TICKET_NO));
    navigate("/ticketDetail", {
      state: {
        ticketNo: ticketInfo.TICKET_NO,
      },
    });
  };

  const LoadSetupProgress = (data) => {
    if (data != null && data.PracticeData != null) {
      const practiceData = data.PracticeData;
      let boxCount = 0;
      for (var i = 0; i < practiceData.length; i++) {
        const filteredData = Identifiers.filter(
          (item) => item === practiceData[i].SEQ_NUM
        );
        if (filteredData && filteredData.length > 0) {
          if (practiceData[i].SEQ_NUM === 12) {
            if (
              (practiceData[i].ACCOUNT_TYPE.toUpperCase() === "LIVE" ||
                practiceData[i].ACCOUNT_TYPE.toUpperCase() === "PRODUCTION") &&
              practiceData[i].ENTRY_DATE &&
              Date.parse(practiceData[i].ENTRY_DATE) <
                Date.parse("2020-06-30T00:00:00")
            ) {
              boxCount++;
            }
          } else {
            boxCount++;
          }
        }
      }
      const percentageToBeAdded = boxCount === 0 ? boxCount : 100 / boxCount;
      CheckPercentage(data, percentageToBeAdded);
    }
  };

  const CheckPercentage = (data, boxCountValue) => {
    Identifiers.forEach((option, key) => {
      const obj = data.PracticeData.find((o) => o.SEQ_NUM === option);
      if (obj) {
        if (obj.SEQ_NUM === 1) {
          if (data.PracticeSetupStatus === "COMPLETED") {
            obj.STATUS = "COMPLETED";
          } else {
            obj.STATUS = "INCOMPLETE";
          }
          obj.TITLE = "Practice Setup";
        }

        if (obj.STATUS !== "INCOMPLETE") {
          if (obj.STATUS === "INPROGRESS") {
            completedPercentage += boxCountValue;
          } else if (obj.STATUS === "NOTNEEDED") {
            completedPercentage += boxCountValue;
          } else {
            completedPercentage += boxCountValue;
          }
        }
      }
    });

    if (completedPercentage > 100) {
      completedPercentage = 100;
    }
    setPercentage(parseInt(completedPercentage));
  };

  const StatusBars = (seq, index) => {
    if (PracticeInfo != null) {
      if (PracticeInfo.length > 0) {
        const tagArray = [];
        let day;
        let month;
        let year;

        const obj = PracticeInfo.find((o) => o.SEQ_NUM === seq);
        if (obj) {
          if (obj.TARGET_COMPLETION_DATE != null) {
            const dateObject = new Date(obj.TARGET_COMPLETION_DATE);
            day = dateObject.getDate();
            month = dateObject.toLocaleString("en-US", { month: "long" });
            year = dateObject.getFullYear();
            month = month.slice(0, 3);
          }

          if (seq === 1) {
            obj.TITLE = "Practice Setup";
            if (Progress.practiceSetupStatus === "COMPLETED") {
              obj.STATUS = "COMPLETED";
            } else {
              obj.TITLE = "Practice Setup";
              obj.STATUS = "INCOMPLETE";
            }
          }

          if (seq === 12) {
            const comment =
              obj.LAST_COMMENT != null
                ? obj.LAST_COMMENT.replace(/(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi, "")
                : "";
            if (
              (obj.ACCOUNT_TYPE.toUpperCase() === "LIVE" ||
                obj.ACCOUNT_TYPE.toUpperCase() === "PRODUCTION") &&
              obj.ENTRY_DATE &&
              Date.parse(obj.ENTRY_DATE) < Date.parse("2020-06-30T00:00:00")
            ) {
              if (obj.STATUS === "COMPLETED" || obj.STATUS === "COMPLETE") {
                tagArray.push(
                  <div
                    className="col-md-12 cursor-pointer"
                    onClick={
                      obj.TITLE !== "Practice Setup"
                        ? () => ShowTicketDetail(obj)
                        : null
                    }
                  >
                    <section>
                      <div className="">
                        <h2>{obj.TITLE}</h2>
                        <p>{comment}</p>
                      </div>
                      <span className="completeTask inprocess-type">
                        COMPLETED
                      </span>
                    </section>
                    <aside>
                      <p id="day" className="font-bold">
                        {day}
                      </p>
                      <p id="month" className="text-center">
                        {month}
                        <span id="year">{year}</span>
                      </p>
                    </aside>
                  </div>
                );
              } else if (obj.STATUS === "INPROGRESS") {
                const comment =
                  obj.LAST_COMMENT !== null
                    ? obj.LAST_COMMENT.replace(
                        /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                        ""
                      )
                    : "";
                tagArray.push(
                  <div
                    className="col-md-12 cursor-pointer"
                    onClick={() => ShowTicketDetail(obj)}
                  >
                    <section>
                      <div className="">
                        <h2>{obj.TITLE}</h2>
                        <p>{comment}</p>
                      </div>
                      <span className="inprogressTask inprocess-type">
                        {obj.STATUS}
                      </span>
                    </section>
                    <aside>
                      <p id="day" className="font-bold">
                        {day}
                      </p>
                      <p id="month" className="text-center">
                        {month}
                        <span id="year">{year}</span>
                      </p>
                    </aside>
                  </div>
                );
              } else if (obj.STATUS === "NOTNEEDED") {
                // completedPercentage += percentageToBeAdded;
                const comment =
                  obj.LAST_COMMENT != null
                    ? obj.LAST_COMMENT.replace(
                        /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                        ""
                      )
                    : "";

                tagArray.push(
                  <div
                    className="col-md-12 cursor-pointer"
                    onClick={
                      obj.TITLE === "e-Prescribing"
                        ? () => ShowTicketDetail(obj)
                        : null
                    }
                  >
                    <section>
                      <div className="">
                        <h2>{obj.TITLE}</h2>
                        <p>{comment}</p>
                      </div>
                      {/* {obj.STATUS} */}
                      <span className="NotNeededTask">NOT NEEDED</span>
                    </section>
                    <aside>
                      <p id="day" className="font-bold">
                        {day}
                      </p>
                      <p id="month" className="text-center">
                        {month}
                        <span id="year">{year}</span>
                      </p>
                    </aside>
                  </div>
                );
              } else {
                const comment =
                  obj.LAST_COMMENT != null
                    ? obj.LAST_COMMENT.replace(
                        /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                        ""
                      )
                    : "";

                tagArray.push(
                  <div className="col-md-12">
                    <section>
                      <div className="">
                        <h2>{obj.TITLE}</h2>
                        <p>{comment}</p>
                      </div>
                      <span className="incompleteTask inprocess-type">
                        {obj.STATUS}
                      </span>
                    </section>
                    <aside>
                      <p id="day" className="font-bold">
                        {day}
                      </p>
                      <p id="month" className="text-center">
                        {month}
                        <span id="year" />
                        {year}
                      </p>
                    </aside>
                  </div>
                );
              }
            }
          } else {
            const comment =
              obj.LAST_COMMENT != null
                ? obj.LAST_COMMENT.replace(/(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi, "")
                : "";
            if (obj.STATUS === "COMPLETED" || obj.STATUS === "COMPLETE") {
              tagArray.push(
                <div
                  className="col-md-12 cursor-pointer"
                  onClick={
                    obj.TITLE !== "Practice Setup"
                      ? () => ShowTicketDetail(obj)
                      : null
                  }
                >
                  <section>
                    <div className="">
                      <h2>{obj.TITLE}</h2>
                      <p>{comment}</p>
                    </div>
                    <span className="completeTask inprocess-type">
                      COMPLETED
                    </span>
                  </section>
                  <aside>
                    <p id="day" className="font-bold">
                      {day}
                    </p>
                    <p id="month" className="text-center">
                      {month}
                      <span id="year">{year}</span>
                    </p>
                  </aside>
                </div>
              );
            } else if (obj.STATUS === "INPROGRESS") {
              const comment =
                obj.LAST_COMMENT != null
                  ? obj.LAST_COMMENT.replace(
                      /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                      ""
                    )
                  : "";
              tagArray.push(
                <div
                  className="col-md-12 cursor-pointer"
                  onClick={() => ShowTicketDetail(obj)}
                >
                  <section>
                    <div className="">
                      <h2>{obj.TITLE}</h2>
                      <p>{comment}</p>
                    </div>
                    <span className="inprogressTask inprocess-type">
                      {obj.STATUS}
                    </span>
                  </section>
                  <aside>
                    <p id="day" className="font-bold">
                      {day}
                    </p>
                    <p id="month" className="text-center">
                      {month}
                      <span id="year">{year}</span>
                    </p>
                  </aside>
                </div>
              );
            } else if (obj.STATUS === "NOTNEEDED") {
              const comment =
                obj.LAST_COMMENT != null
                  ? obj.LAST_COMMENT.replace(
                      /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                      ""
                    )
                  : "";
              tagArray.push(
                <div
                  className="col-md-12 cursor-pointer"
                  onClick={
                    obj.TITLE === "e-Prescribing"
                      ? () => ShowTicketDetail(obj)
                      : null
                  }
                >
                  <section>
                    <div className="">
                      <h2>{obj.TITLE}</h2>
                      <p>{comment}</p>
                    </div>
                    <span className="NotNeededTask">NOT NEEDED</span>
                  </section>
                  <aside>
                    <p id="day" className="font-bold">
                      {day}
                    </p>
                    <p id="month" className="text-center">
                      {month}
                      <span id="year">{year}</span>
                    </p>
                  </aside>
                </div>
              );
            } else {
              const comment =
                obj.LAST_COMMENT != null
                  ? obj.LAST_COMMENT.replace(
                      /(<br\s*\/?>|<p\s*\/?>|<\/p>)/gi,
                      ""
                    )
                  : "";
              tagArray.push(
                <div className="col-md-12">
                  <section>
                    <div className="">
                      <h2>{obj.TITLE}</h2>
                      <p>{comment}</p>
                    </div>
                    <span className="incompleteTask inprocess-type">
                      {obj.STATUS}
                    </span>
                  </section>
                  <aside>
                    <p id="day" className="font-bold">
                      {day}
                    </p>
                    <p id="month" className="text-center">
                      {month}
                      <span id="year" />
                      {year}
                    </p>
                  </aside>
                </div>
              );
            }
          }
        }
        return tagArray;
      }
    }
  };

  const PendingTickets = () => {
    let count = 0;
    if (AllTasks) {
      AllTasks.forEach((row) => {
        if (row.STATUS === "I" || row.STATUS === "O") {
          count += 1;
        }
      });
    }

    return count;
  };
  const ResolvedTasks = () => {
    let count = 0;
    if (AllTasks) {
      AllTasks.forEach((row) => {
        if (row.STATUS === "R") {
          count += 1;
        }
      });
    }
    return count;
  };
  const PendingOnClientTickets = () => {
    let count = 0;
    if (AllTasks) {
      AllTasks.forEach((row) => {
        if (row.STATUS === "Q") {
          count += 1;
        }
      });
    }
    return count;
  };
  const ClientService = () => {
    const speciality = ClientInfo.SPECIALITY
      ? ClientInfo.PRACTICE_CITY
        ? `${ClientInfo.SPECIALITY}/ ${ClientInfo.PRACTICE_CITY}`
        : ClientInfo.SPECIALITY
      : "";

    if (ClientInfo.PRACTICE_NAME || speciality) {
      let ClientServices = "(";
      if (ClientInfo.RCMTYPE === "Y") {
        ClientServices += "RCM";
      } else {
        ClientServices += ClientInfo.BILLING_FLAG === "Y" ? "EHR/EHRPM" : "EHR";
        ClientServices += ClientInfo.CHTYPE === "Y" ? "/Clearing House" : "";
      }
      ClientServices += ")  ";
      if (ClientInfo.IS_TELE_CLINIC === "Y" || ClientInfo.KIOSK_FLAG === "Y") {
        ClientServices += "(";
        ClientServices += ClientInfo.IS_TELE_CLINIC === "Y" ? "Tele visit" : "";
        ClientServices +=
          ClientInfo.IS_TELE_CLINIC === "Y" && ClientInfo.KIOSK_FLAG === "Y"
            ? ", "
            : "";
        ClientServices += ClientInfo.KIOSK_FLAG === "Y" ? "Kiosk" : "";
        ClientServices += ")";
      }

      return ClientServices;
    }
  };
  const OverDueTask = () => {
    let count = 0;
    if (Progress.overDueTask) {
      count = Progress.overDueTask.length;
    }
    return count;
  };

  const HandlePopup = (childData, type) => {
    if (type === "task") {
      setPopupTask(false);
      if (childData === true) {
        LoadProgressData();
      }
    } else {
      setPopupNote(false);
    }
  };

  const ShowPopup = (type) => {
    if (type === "task") {
      setPopupTask(!PopupTask);
    } else {
      setPopupNote(!PopupNote);
    }
  };

  const ShowClientDetail = (key) => {
    dispatch(setSearchFrom("dashboard"));
    navigate("/client-detail", {
      state: {
        ClientId: key,
        CurrentTab: "ClientDetail",
      },
    });
  };

  const ShowTasks = (value) => {
    dispatch(setSearchFrom("dashboard"));
    dispatch(clearTicketTaskFilters());
    dispatch(setTicketCustomerId(ClientInfo.AUTH_ENTITY_SEQ_NUM));
    // dispatch(setClientId(ClientInfo.AUTH_ENTITY_SEQ_NUM));
    dispatch(setStatus(value));
    dispatch(setType("Task"));
    navigate("/tickets");
  };

  return (
    <div>
      {PopupTask && <NewTask parentCallback={HandlePopup} />}

      {PopupNote && <NewNote type="create" parentCallback={HandlePopup} />}

      <div>
        <ul className="flex justify-content-between listHeader listProgress h-4rem">
          <li className="flex flex-auto my-auto">
            <div id="ClientName" className="w-fit">
              {ClientInfo ? ClientInfo.PRACTICE_NAME : ""}
              <span
                className="underline cursor-pointer"
                onClick={() => ShowClientDetail(props?.data.customerId)}
              >
                ({props?.data.customerId})
              </span>
            </div>
            <div id="ClientServices" className="ml-3">
              {ClientInfo ? ClientService() : ""}
            </div>
          </li>
          {progressData && (
            <li className="mr-2 text-right" id="SetupProgressItem">
              <div className="pHeader w-full">
                <div>
                  <strong className="text-sm">Setup Progress</strong>{" "}
                  {percentage}%
                </div>
              </div>
              <div
                id="setupProgressBardiv"
                className="pBar"
                data-from={percentage}
                data-to="0"
              >
                <span
                  id="setupProgressBarspan"
                  style={{ width: `${percentage}%` }}
                >
                  &nbsp;
                </span>
              </div>
            </li>
          )}
        </ul>

        {progressData === true ? (
          <div className="mainSetup progress-setup">
            <div className="arrow_box d-none">
              <p>* This Client is given 20% discount for the first year</p>
            </div>
            <div className="blueContainer" id="progressDataUpperBar">
              <div className="bluePanelTask">
                <h2>Implementation &amp; Training Tasks</h2>
              </div>
              <div className="bluePanelCounts">
                <p onClick={() => ShowTasks("P")}>
                  <span id="PendingTickets">{PendingTickets()}</span>
                  Pending
                </p>
                <p onClick={() => ShowTasks("Q")}>
                  <span id="pendingOnClientTickets">
                    {PendingOnClientTickets()}
                  </span>
                  Pending On Client
                </p>
                <p onClick={() => ShowTasks("O")}>
                  <span id="overDueTickets">{OverDueTask()}</span>
                  Over Due
                </p>
                <p onClick={() => ShowTasks("R")}>
                  <span id="completedTickets">{ResolvedTasks()}</span>
                  Completed
                </p>
              </div>
              <div className="bluePanelNewTask">
                <span role="button" onClick={() => ShowPopup("task")}>
                  New Task
                </span>

                <span role="button" onClick={() => ShowPopup("note")}>
                  Notes
                </span>
              </div>
            </div>
            <div className="tasksList" id="Practice_Progress">
              <div className="row">
                {Identifiers.map((item, index) => (
                  <div key={index}>{StatusBars(item, index)}</div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-center justify-content-center noDataFound noDataFound progress-setup mainSetup">
            No Data Found
          </div>
        )}
      </div>
    </div>
  );
});

export default ClientProgress;
